// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"deposit-list_clearfix_2SgWH"};